import React, { useEffect, useState, useRef } from 'react';
import {
    MDBCard,
    MDBCardBody,
    MDBBtn,
    MDBRow,
    MDBCol,
    MDBIcon,
    MDBSpinner
} from 'mdb-react-ui-kit';
import GymLogo from '../components/images/Easy-MembrLogo.png';
import { checkMembers, getPlans, logEvent } from "../services/apiServices";
import { useLocation, useNavigate } from "react-router-dom";
import { getBusinessName, resumeMemberShip } from "../services/apiServices"
import defaultImg from "./../components/images/defaultPerson.png";
import { browserName, browserVersion } from "react-device-detect";
import { BasePlanName } from '../utils/BasePlanName';
import { useAnalytics } from '../hooks/useAnalytics';

const QRCheckin = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { data: _rawData, currentGymId, isMultiGym, homeGymId, validationData, activeClass } = location.state || {};

    // Normalize data to always be an array — avoids const-reassignment crash
    const data = _rawData ? (Array.isArray(_rawData) ? _rawData : [_rawData]) : null;

    const { trackButtonClick } = useAnalytics();

    const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"))?.name;

    // Ref keeps businessData always fresh inside async confirm handler
    const businessDataRef = useRef(null);
    const [timer, setTimer] = useState(30);
    const [loading, setLoading] = useState(false);
    const [isExpired, setIsExpired] = useState(false);
    const [businessData, setBusinessData] = useState(null);

    // const[planInfo, setPlanInfo] = useState(null); 

    // const planInfo =
    //     data && data.length > 0
    //         ? (
    //             data[0].plan?.find((item) => item._id === data[0].planid) ||
    //             data[0].subplan?.find((item) => item._id === data[0].planid) ||
    //             {}
    //         )
    //         : {};

    const [planInfo, setPlanInfo] = useState({});


    useEffect(() => {
        const storedPlanInfo = localStorage.getItem("planInfo");
        if (storedPlanInfo) {
            setPlanInfo(JSON.parse(storedPlanInfo));
        }
    }, []);

    let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;



    const [plans, setPlans] = useState("");


    const handleArrow = () => {
        navigate("/qrscanner");
    }

    useEffect(() => {
        if (!data?.[0]) {
            navigate("/");
        }
    }, [data]);





    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const response = await getPlans(data?.[0]?.bId);

                if (!response) return;
                if (response === "false") return;

                const plans = await response.json();
                if (!plans) return;


                setPlans(plans);

                // Modified lookup with fallback to plans array
                let selectedPlan =
                    data?.[0]?.plan?.find((item) => item._id === data?.[0]?.planid) ||
                    data?.[0]?.subplan?.find((item) => item._id === data?.[0]?.planid) ||
                    plans.find((plan) => plan._id === data?.[0]?.planid) ||
                    {};



                if (selectedPlan?.baseplan) {
                    const baseName = BasePlanName(plans, selectedPlan.baseplan);
                    selectedPlan.displayName = `${baseName}-${selectedPlan.name}`;
                } else {
                    selectedPlan.displayName = selectedPlan?.name;
                }
                console.log("selectedPlanselectedPlan", selectedPlan)

                localStorage.setItem("planInfo", JSON.stringify(selectedPlan));
                setPlanInfo(selectedPlan); // Also update state immediately

            } catch (error) {
                console.error("Error fetching plans:", error);
            }
        };

        fetchPlans();
    }, [data]);




    useEffect(() => {
        let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;

        if (plansInfo != null && plansInfo?.feature?.qrcheckin != true) {
            navigate("/qrlogin");
        }
    }, [navigate]);



    useEffect(() => {
        if (data?.[0]?.expirydate) {
            const expiryDate = new Date(data[0].expirydate);
            setIsExpired(expiryDate <= new Date());
        }
    }, [data]);

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(interval);
        } else if (timer === 0) {
            // handleConfirm is async — it records attendance and navigates on success.
            // Do NOT call handleArrow here; it would navigate away before the API responds.
            handleConfirm();
        }
    }, [timer]);

    const handleConfirm = async () => {

        // const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};

        if (!data || !data[0]) {
            return;
        }

        if (data[0]?.issuspend) {
            return;
        }

        const chekinflag = data[0]?.checkinflag === 1 ? "0" : "1";
        const id = data[0]?.bId;
        const mId = data[0]?._id;
        const planName = planInfo;

        if (!id || !mId || !planName) {
            return;
        }
        const loggedUserGymname = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymname;

        let updates = {
            checkFlag: chekinflag,
            gymid: id,
            bId: id,
            mid: mId,
            _id: mId,
            date: new Date(),
            fvalue: "pos",
            selectedplan: planName,
            partnerGymId: isMultiGym ? currentGymId : null,
            venuename: loggedUserGymname || "partnergym",
            // Use ref so we always get the latest value even if state hasn't flushed
            homegymname: businessDataRef.current?.businessName || businessData?.businessName || "",
        };
        console.log(activeClass)
        if (activeClass) {
            updates.selectedplan = null;
            updates.autocheckout = new Date(activeClass?.expirydate);
            updates.scheduletransid = activeClass?._id;
            updates.trainer = (activeClass?.staff?.firstname + " " + activeClass?.staff?.lastname);
            updates.trainerid = activeClass?.staff?._id;
        }
        console.log("updatesupdates", updates)



        setLoading(true);

        console.log("updates", updates)

        try {
            const response = await checkMembers(updates, mId);

            if (chekinflag === "1") {
                await handleResumeAfterCheckin(data[0]);
            }

            const message = chekinflag === "1"
                ? `Successfully Checked In${isMultiGym ? ' at Partner Gym' : ''}`
                : `Successfully Checked Out${isMultiGym ? ' from Partner Gym' : ''}`;
            await trackButtonClick("logatime", "Member_Check-in", "staff", {});
            navigate("/qrscanner", {
                state: {
                    successMessage: message,
                    showSuccess: true
                }
            });
            setTimer(30);
        } catch (error) {
            console.error("Error during check-in:", error);
        } finally {
            setLoading(false);
        }
    };



    const handleResumeAfterCheckin = async (memberData) => {
        try {
            console.log("Full memberData:", memberData);
            let pauseData = [];
            if (memberData.trans && memberData.trans.length > 0) {
                console.log("Checking trans array:", memberData.trans[0]);
                if (memberData.trans[0].pause && memberData.trans[0].pause.length > 0) {
                    console.log("Found pause data in trans:", memberData.trans[0].pause);
                    pauseData = [memberData.trans[0].pause.sort((a, b) => b.sno - a.sno)[0]];
                    console.log("Latest pause data:", pauseData[0]);
                }
            }
            if (pauseData.length === 0 && memberData.plan && memberData.plan.length > 0) {
                console.log("Checking plan array for pause data:", memberData.plan[0]);
                if (memberData.plan[0].pause && memberData.plan[0].pause.length > 0) {
                    console.log("Found pause data in plan:", memberData.plan[0].pause);
                    pauseData = [memberData.plan[0].pause.sort((a, b) => b.sno - a.sno)[0]];
                }
            }

            console.log("Final pauseData:", pauseData);
            const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
            const id = loggedUserInfo.gymid || "";
            const ip = localStorage.getItem("ipaddress");
            const browserinfo = `${browserName}-${browserVersion}.0.0`;
            const Eventtype = "Membership";
            const gymid = id;
            const username1 = loggedUserInfo.email || "";
            if (pauseData.length > 0 && pauseData[0].resume === true) {
                console.log("Member has paused status with resume=true, proceeding with resume...");

                let transaction = memberData.trans?.[0];

                if (!transaction) {
                    console.warn("No transaction found for resume");
                    return;
                }

                let pausedDate = new Date(pauseData[0].fromtime);
                let currentTime = new Date();
                currentTime.setHours(pausedDate.getHours());
                currentTime.setMinutes(pausedDate.getMinutes());
                currentTime.setSeconds(pausedDate.getSeconds());
                currentTime.setMilliseconds(pausedDate.getMilliseconds());

                let OldPausedDate = new Date(pauseData[0].totime);
                const dayDifference = (OldPausedDate - currentTime) / (1000 * 60 * 60 * 24);

                let enddate = new Date(transaction.expirydate);
                enddate.setDate(enddate.getDate() - Math.ceil(dayDifference));

                let updates = {
                    date: pauseData[0].date,
                    fromtime: pauseData[0].fromtime,
                    totime: currentTime,
                    resume: false,
                    sno: pauseData[0].sno,
                    enddate: enddate,
                    transaction: transaction,
                    gymid: memberData.bId,
                };

                await resumeMemberShip(memberData.bId, updates);

                let flag = `Plan Resume Successful (${memberData.fname} ${memberData.lname})`;
                await logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);

                console.log("Member successfully resumed after QR check-in");
            }
        } catch (error) {
            console.error("Error during resume after check-in:", error);
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const datar = data?.[0]?.bId;
                console.log("datar value:", datar);

                if (datar) {
                    const updates = { bId: datar };
                    console.log("Request payload:", updates);

                    const result = await getBusinessName(updates);

                    console.log("API result:", result);

                    if (result && result.json) {
                        const jsonData = await result.json();
                        businessDataRef.current = jsonData;
                        setBusinessData(jsonData);
                    } else {
                        console.error("API returned no data or null.");
                    }
                } else {
                    console.log("datar is undefined or null. Skipping API call.");
                }
            } catch (error) {
                console.error("Error fetching business name:", error);
            }
        };

        fetchData();
    }, []);

    function getExpiryDate(data) {
        try {
            console.log(data);

            let startdate = new Date();

            let enddate = data.expirydate;
            console.log(startdate);
            console.log(enddate);
            let expirydate = new Date(enddate).getTime() - startdate.getTime();
            let cd = 24 * 60 * 60 * 1000;
            console.log(Math.floor(expirydate / cd));
            let exdays = Math.floor(expirydate / cd) + 1;
            return exdays >= 1
                ? exdays + " Day(s)"
                : data.attendance[0] &&
                    new Date(data.attendance[0].intime).getTime() >=
                    new Date(enddate).getTime()
                    ? "Expired (Overdue)"
                    : "Expired";
        } catch (e) {
            console.log("Error :::::::::::::::: " + e);
        }
    }

    return (
        <div className="h-100vhWave p-0 h-100">
            <div className="qrlayout h-100">
                <div className='row justify-content-center h-100 align-items-center'>
                    <MDBCard className='col-12 col-md-5 qrcard'>
                        <MDBCardBody className='py-3 '>
                            <div className='position-relative d-flex flex-column h-100'>
                                <div className="mobile-Head pb-4 d-flex justify-content-between">
                                    {/* <div className='d-flex align-items-center'>
                                    <MDBIcon fas icon="arrow-left" className="fs-5" onClick={handleArrow} />
                                    <h5 className="m-0 ps-3">User Information</h5>
                                </div> */}
                                    <div className='d-flex align-items-center justify-content-between Waiver-logo'>
                                        <img src={GymLogo} className="w-20 mob-w-40" alt="Gym Logo" />
                                        {businessData?.logourl && <img
                                            src={businessData?.logourl || ""}
                                            alt={GymLogo}
                                            className="w-20 mob-w-40"
                                        />}
                                    </div>

                                </div>

                                <div className='qrcard-body'>
                                    <div className='mb-4'>

                                        <div className='text-center'>

                                            {plansInfo != null && (plansInfo?.feature?.uploadlogo != false)
                                                && <div className='usershow'>
                                                    <img src={data && data.length > 0 && data[0]?.imgurl ? data[0].imgurl : defaultImg}
                                                        alt="Image" />
                                                </div>}
                                            <h5 className="my-3 ps-3">
                                                {data?.[0]?.fname
                                                    ? `${data[0].fname} ${data[0].lname}`
                                                    : "N/A"}
                                            </h5>
                                        </div>


                                        <div className='tabledata'>
                                            <div className='d-flex tablewrap'>
                                                <div>
                                                    <table className='userview-table'>
                                                        <tbody>
                                                            <tr>
                                                                <td className='titel-text' width={130}>Member Id</td>
                                                                <td ><label>{data?.[0]?.mid || "N/A"}</label> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className='titel-text'>Contact No</td>
                                                                <td ><label>{data?.[0]?.number || "N/A"}</label></td>
                                                            </tr>
                                                            <tr>
                                                                <td className='titel-text'>Gender</td>
                                                                <td ><label>{data?.[0]?.sex || "N/A"}</label></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div>
                                                    <table className='userview-table'>
                                                        <tbody>
                                                            <tr>
                                                                <td className='titel-text' width={130}>Height</td>
                                                                <td><label>{data?.[0]?.height ?? "N/A"}</label></td>
                                                            </tr>

                                                            <tr>
                                                                <td className='titel-text' width={130}>Weight</td>
                                                                <td><label>{data?.[0]?.weight ?? "N/A"}</label></td>
                                                            </tr>
                                                            <tr>
                                                                <td className='titel-text'>Blood Group</td>
                                                                <td><label>{data?.[0]?.bloodgroup || "N/A"}</label></td>
                                                            </tr>


                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                            <div>
                                                <div>
                                                    <table className='userview-table w-100'>
                                                        <tr>
                                                            <td className='titel-text' width={130} >E-mail id</td>
                                                            <td><label>{data?.[0]?.email || "N/A"}</label></td>
                                                        </tr>
                                                    </table>

                                                </div>
                                                <table className='userview-table w-100'>
                                                    <tbody>
                                                        <tr>
                                                            <td className='titel-text' width={130}>{!activeClass ? "Plan" : "Class"}</td>
                                                            <td >
                                                                {activeClass ?
                                                                    <div className='d-flex align-items-center'>
                                                                        <label> {activeClass?.class?.name} </label>
                                                                    </div>
                                                                    : <div className='d-flex align-items-center'>

                                                                        <label className={` ${(data?.[0]?.plan?.length > 0 || data?.[0]?.subplan?.length > 0) > 0 ? "text-success" : "text-danger"}`}>  {planInfo ? `${planInfo.
                                                                            displayName || "N/A"}` : "No Plan"} </label>

                                                                        <div>
                                                                            <div>
                                                                                {(data?.[0]?.plan?.length > 0 || data?.[0]?.subplan?.length > 0) > 0 && !data?.[0]?.issuspend && (
                                                                                    <div className='d-flex align-items-center'>
                                                                                        <div className={parseFloat(getExpiryDate(data && data.length > 0 ? data[0] : {})) > 6 ? "clr-green px-1 button-text" : [parseFloat(getExpiryDate(data && data.length > 0 ? data[0] : {})) > 0 ? "clr-orange button-text" : "clr-red button-text"]}>
                                                                                            ({getExpiryDate(data && data.length > 0 ? data[0] : {}) || "0 Day(s)"})
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                            </div>
                                                                            {!data?.[0]?.issuspend ? (
                                                                                (data?.[0]?.plan?.length > 0 || data?.[0]?.subplan?.length > 0) ? (
                                                                                    isExpired ? (
                                                                                        <p className="text-danger mt-3">Plan has been expired</p>
                                                                                    ) : null
                                                                                ) : null
                                                                            ) : (
                                                                                <p className="text-danger mt-3">Member is suspended</p>
                                                                            )}
                                                                        </div>
                                                                    </div>}

                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>






                                    </div>

                                    <div className="d-flex flex-column align-items-center">
                                        <div
                                            className="rounded-circle d-flex align-items-center justify-content-center mb-4"
                                            style={{
                                                width: "80px",
                                                height: "80px",

                                                backgroundColor: `${timer > 20 ? "#c3f1dc" : (timer <= 20 && timer > 10) ? "#fce6c6" : "#fcc6c6"}`,
                                                color: `${timer > 20 ? "#0c806c" : (timer <= 20 && timer > 10) ? "#ce8410" : "#ce1010"}`,



                                                // backgroundColor: "#fce6c6",
                                                //color: "#ce8410",

                                                // color: "#ce1010",
                                                // backgroundColor: "#fcc6c6",


                                                fontSize: "24px",
                                                fontWeight: "bold",

                                            }}
                                        >
                                            {timer}


                                        </div>
                                        <div className="d-flex align-items-center justify-content-center w-100">

                                            <MDBBtn color='' className="w-50 qr-btn me-2" outline onClick={handleArrow} >Cancel</MDBBtn>

                                            {!data?.[0]?.issuspend && !isExpired && (data?.[0]?.plan?.length > 0 || data?.[0]?.subplan?.length > 0) > 0 && (

                                                <MDBBtn
                                                    className="w-50"
                                                    size="lg"
                                                    color={data?.[0]?.checkinflag === 1 ? "danger" : "success"}
                                                    onClick={handleConfirm}
                                                    disabled={loading}
                                                    style={{
                                                        backgroundColor: data?.[0]?.checkinflag === 1 ? "red" : "",
                                                        color: data?.[0]?.checkinflag === 1 ? "black" : "",
                                                    }}
                                                >
                                                    {loading ? (
                                                        <MDBSpinner size="sm" role="status" />
                                                    ) : (
                                                        data?.[0]?.checkinflag === 1 ? "Checkout" : "Checkin"
                                                    )}
                                                </MDBBtn>
                                            )}

                                        </div>




                                    </div>
                                </div>
                            </div>
                        </MDBCardBody>

                    </MDBCard>
                </div>
            </div>
        </div >
    );
};

export default QRCheckin;
